import { WorkflowType } from '../enums';
import { FileStorageType } from '../types/file-storage-type.type';
import { ResultState } from '../types/result-state.type';
import { ResultModule } from './result-module.model';
import { SegmentationOutputResult } from './segmentation-output-result.model';
import { WorkflowResultShare } from './workflow-result-share.model';

export class Result {
    id: string;
    userId: string;
    batchCorrelationId?: string;
    title: string;
    description?: string;
    createdAt?: string;
    startedAt?: string;
    finishedAt: string;
    internalId?: string;
    state: ResultState;
    workflowInstanceId: string;
    workflowRunId: string;
    isValidForPredictionsView: boolean;
    workflowId?: string;
    modules?: ResultModule[];
    workflowResultShares?: WorkflowResultShare[] = [];
    ErrorReportStatus?: boolean;
    storageType: FileStorageType;
    workflowType: WorkflowType;
    email?: string;
    userFullName?: string;
    role?: string;
    subscription?: string;

    constructor(resultModel?: Result) {
        if (resultModel != null) {
            this.id = resultModel.id;
            this.userId = resultModel.userId;
            this.batchCorrelationId = resultModel.batchCorrelationId;
            this.title = resultModel.title;
            this.description = resultModel.description;
            this.createdAt = resultModel.createdAt;
            this.startedAt = resultModel.startedAt;
            this.finishedAt = resultModel.finishedAt;
            this.internalId = resultModel.internalId;
            this.state = resultModel.state;
            this.workflowInstanceId = resultModel.workflowInstanceId;
            this.workflowRunId = resultModel.workflowRunId;
            this.isValidForPredictionsView = resultModel.isValidForPredictionsView;
            this.workflowId = resultModel.workflowId;
            this.modules = resultModel.modules;
            this.workflowResultShares = resultModel.workflowResultShares;
            this.ErrorReportStatus = resultModel.ErrorReportStatus;
            this.storageType = resultModel.storageType;
            this.workflowType = resultModel.workflowType;
            this.email = resultModel.email;
            this.userFullName = resultModel.userFullName;
            this.role = resultModel.role;
            this.subscription = resultModel.subscription;
        }
    }

    get publicShareId(): string | undefined {
        return this.workflowResultShares?.find(x => x.type === 'Public')?.shareId;
    }

    get adminShareId(): string | undefined {
        return this.workflowResultShares?.find(wfr => wfr.type === 'Admin')?.shareId;
    }
}

export interface ResultOverview {
    id: string;
    segmentationResultId: string;
    title: string;
    status: 'running' | 'complete' | 'failed' | 'pending' | 'enqueued' | 'cancelled';
    startedAt: string;
    applicationId?: string;
    applicationName?: string;
    mlModelVersion?: number;
    batchCorrelationId?: string;
    state?: string;
    workflowType: WorkflowType;
}

export interface ResultDetail extends SegmentationOutputResult {
    applicationName: string;
    embedTokens?: EmbedToken[];
}

export interface EmbedToken {
    id: string;
    name: string;
    embedUrl: string;
    accessToken: string;
}
